/* Sticky Add-to-Cart.

   Zwei Aufgaben:
   1. Leiste an <body> haengen. Sie wird im Produktformular gerendert, das in
      einem Element mit transform liegt (scroll-trigger animate--slide-in).
      Ein transformierter Vorfahre wird zum Bezugsrahmen fuer position:fixed —
      die Leiste klebte sonst mitten in der Seite statt am Viewport.
   2. Einblenden, sobald der Haupt-Kaufbutton nach oben aus dem Bild ist.

   Bewusst ein passiver Scroll-Listener statt IntersectionObserver: der
   Zustand wird auch bei Layoutwechseln ohne Scroll-Ereignis korrekt gesetzt
   (Varianten-Update, Section-Reload im Editor, Drehen des Geraets), und die
   Auswertung haengt an requestAnimationFrame, kostet also nichts.

   Der Klick delegiert an den Haupt-Button, damit Dawns product-form.js den
   Rest uebernimmt (AJAX-Add, Fehlermeldung, Cart-Drawer). */
(function () {
  var bar = null;
  var anchor = null;
  var ticking = false;

  function update() {
    ticking = false;
    if (!bar || !anchor) return;
    // Sichtbar, sobald der Haupt-Kaufbutton komplett nach oben raus ist.
    var scrolledPast = anchor.getBoundingClientRect().bottom < 0;
    bar.classList.toggle('is-visible', scrolledPast);
    bar.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function init() {
    var bars = document.querySelectorAll('[data-sticky-atc]');
    if (!bars.length) return;

    // Nach einem Section-Reload im Theme-Editor kann eine alte Leiste am body
    // haengen. Es gilt immer die zuletzt gerenderte.
    bar = bars[bars.length - 1];
    for (var i = 0; i < bars.length - 1; i++) bars[i].remove();

    var mainButton = document.querySelector('.product-form__submit');
    anchor = document.querySelector('.product-form__buttons');

    if (!mainButton || !anchor) {
      bar.remove();
      bar = null;
      return;
    }

    if (bar.parentElement !== document.body) document.body.appendChild(bar);

    if (bar.dataset.stickyAtcReady !== 'true') {
      bar.dataset.stickyAtcReady = 'true';

      var button = bar.querySelector('[data-sticky-atc-button]');
      if (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          mainButton.click();
        });
      }
    }

    update();
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
